// src/pages/categories/SmartWaterMonitor.jsx
import React, { useEffect, useState } from "react";

import mobile1 from "../../assets/images/air-cerdas/tampilan_mobile_apps-1.jpeg";
import mobile2 from "../../assets/images/air-cerdas/tampilan_mobile_apps-2.jpg";
import mobile3 from "../../assets/images/air-cerdas/tampilan_mobile_apps-3.jpeg";
import mobile4 from "../../assets/images/air-cerdas/tampilan_mobile_apps-4.jpeg";
import mobile5 from "../../assets/images/air-cerdas/tampilan_mobile_apps-5.jpeg";
import mobile6 from "../../assets/images/air-cerdas/tampilan_mobile_apps-6.jpeg";
import mobile7 from "../../assets/images/air-cerdas/tampilan_mobile_apps-7.jpeg";

import web1 from "../../assets/images/air-cerdas/tampilan-web-dashboard-1.PNG";
import web2 from "../../assets/images/air-cerdas/tampilan-web-dashboard-2.PNG";
import web3 from "../../assets/images/air-cerdas/tampilan-web-dashboard-3.PNG";
import web4 from "../../assets/images/air-cerdas/tampilan-web-dashboard-4.PNG";
import web5 from "../../assets/images/air-cerdas/tampilan-web-dashboard-5.PNG";

import imgMonitoringTotal from "../../assets/images/air-cerdas/monitoring total.jpg";
import imgTitikKebocoran from "../../assets/images/air-cerdas/mengetahui titik kebocoran.jpg";

const PRICE_OLD = "Rp400.000";
const PRICE_NEW = "Rp190.000";
const WA_NUMBER = "6285122019659";

const TOKPED_URL =
  "https://www.tokopedia.com/solusi-iot-cerdas/sistem-pemantauan-air-berbasis-iot-pipa-1-2-inchi-air-cerdas-pantau-pengunaanan-air-berapa-liter-yang-digunakan-anti-bocor-hemat-tagihan-pdam-hemat-listrik-untuk-rumah-tinggal-kontrakan-kost-apartemen-kantor-1731948329540552102?extParam=whid%3D20289209%26src%3Dshop&aff_unique_id=&channel=others&chain_key=";

const SHOPEE_URL =
  "https://shopee.co.id/Sistem-Pemantauan-Air-Berbasis-IoT-pipa-1-2-inch-Hemat-Air-Hemat-Listrik-Anti-Kebocoran-Air-i.1572877014.29388692719?extraParams=%7B%22display_model_id%22%3A270721254914%2C%22model_selection_logic%22%3A3%7D";

const MOBILE_IMAGES = [
  mobile1,
  mobile2,
  mobile3,
  mobile4,
  mobile5,
  mobile6,
  mobile7,
];
const WEB_IMAGES = [web1, web2, web3, web4, web5];

const benefits = [
  {
    title: "Pantau dari HP",
    description:
      "Anda bisa melihat pemakaian air dengan lebih praktis tanpa harus bolak-balik cek meter secara manual.",
  },
  {
    title: "Lebih Cepat Tahu Kalau Ada yang Tidak Wajar",
    description:
      "Saat pemakaian terasa melonjak, Anda bisa lebih cepat sadar dan segera cek sumber masalahnya.",
  },
  {
    title: "Bantu Kontrol Biaya Air",
    description:
      "Bukan sekadar melihat air terpakai, tetapi membantu Anda lebih sadar ke mana pengeluaran air berjalan.",
  },
  {
    title: "Cocok untuk Kebutuhan Harian",
    description:
      "Bisa dipakai untuk rumah, kos, kontrakan, ruko, sampai bangunan sewa skala kecil.",
  },
];

const targetUsers = [
  {
    title: "Pemilik Kos",
    description:
      "Kebocoran kecil atau pemakaian berlebihan bisa diam-diam menggerus margin usaha Anda.",
    image: "/images/targets/target-kosan.webp",
    alt: "Pemilik Kos",
  },
  {
    title: "Pemilik Kontrakan",
    description:
      "Semakin banyak unit, semakin penting punya kontrol yang rapi atas pemakaian air.",
    image: "/images/targets/target-ruko.webp",
    alt: "Pemilik Kontrakan",
  },
  {
    title: "Pemilik Ruko atau Tempat Usaha",
    description:
      "Air yang terus mengalir tanpa disadari bisa menaikkan biaya operasional dari bulan ke bulan.",
    image: "/images/targets/target-ruko.webp",
    alt: "Pemilik Ruko",
  },
  {
    title: "Pemilik Rumah",
    description:
      "Kalau Anda pernah bingung kenapa tagihan tiba-tiba naik, sistem ini bisa jadi langkah awal yang membantu.",
    image: "/images/targets/target-perumahan.webp",
    alt: "Pemilik Rumah",
  },
  {
    title: "Pengelola Apartemen Kecil atau Properti Sewa",
    description:
      "Pilihan yang ringan untuk mulai memantau penggunaan air dengan cara yang lebih modern.",
    image: "/images/targets/target-apartemen.webp",
    alt: "Pengelola Apartemen",
    wide: true,
  },
];

const reasonsToChoose = [
  {
    title: "Lebih mudah dipahami",
    description:
      "Tampilannya dibuat supaya orang awam pun bisa mulai memahami pemakaian air tanpa merasa ribet.",
  },
  {
    title: "Bisa mulai bertahap",
    description:
      "Anda tidak harus langsung pasang banyak sensor. Mulai dari satu titik dulu juga sudah masuk akal.",
  },
  {
    title: "Ada pendampingan awal",
    description:
      "Anda mendapat video panduan instalasi dan bisa bertanya kalau masih bingung saat pemasangan.",
  },
];

const faqs = [
  {
    question: "Apakah Air Cerdas cocok untuk rumah saya?",
    answer:
      "Ya. Air Cerdas cocok untuk rumah, kos, kontrakan, ruko, apartemen kecil, dan properti sewa yang ingin mulai memantau pemakaian air dengan lebih rapi.",
  },
  {
    question: "Apakah alat ini hanya untuk bangunan besar?",
    answer:
      "Tidak. Justru alat seperti ini sangat relevan untuk kebutuhan harian, terutama saat Anda ingin mulai lebih sadar terhadap pemakaian dan biaya air.",
  },
  {
    question: "Apakah instalasinya sulit?",
    answer:
      "Kami menyediakan video panduan instalasi dan pendampingan awal, jadi Anda tidak dibiarkan pasang sendiri tanpa arahan.",
  },
  {
    question: "Kalau saya masih awam, apakah tetap bisa dibantu?",
    answer:
      "Bisa. Halaman ini memang ditulis untuk pengguna awam, dan setelah pembelian Anda juga tetap bisa bertanya bila menemui kendala dasar.",
  },
  {
    question: `${PRICE_NEW} per produk itu untuk apa?`,
    answer: `Itu adalah harga promo per produk untuk memudahkan Anda mulai dari biaya awal yang lebih ringan. Cocok untuk yang ingin coba di satu titik terlebih dahulu.`,
  },
  {
    question: "Kalau setelah beli saya masih bingung bagaimana?",
    answer:
      "Anda tetap bisa menghubungi kami. Tujuannya bukan hanya alat sampai, tetapi alat benar-benar bisa digunakan.",
  },
];

const createWaLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

const buttonPrimaryClass =
  "inline-flex items-center justify-center bg-green-600 text-white font-bold px-8 py-4 rounded-full shadow-lg hover:bg-green-700 transition-all duration-300 hover:scale-[1.02]";

const buttonSecondaryClass =
  "inline-flex items-center justify-center bg-white dark:bg-gray-800 text-gray-800 dark:text-white font-bold px-8 py-4 rounded-full shadow border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-300 hover:scale-[1.02]";

const ChevronIcon = () => (
  <svg
    fill="none"
    height="24"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    width="24"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const SmartWaterMonitor = () => {
  const [mobileIndex, setMobileIndex] = useState(0);
  const [webIndex, setWebIndex] = useState(0);

  useEffect(() => {
    const originalTitle = document.title;

    const upsertMeta = (selector, attrName, attrValue, content) => {
      let tag = document.querySelector(selector);
      const created = !tag;

      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attrName, attrValue);
        document.head.appendChild(tag);
      }

      const previousContent = tag.getAttribute("content");
      tag.setAttribute("content", content);

      return () => {
        if (created) {
          tag.remove();
        } else if (previousContent !== null) {
          tag.setAttribute("content", previousContent);
        } else {
          tag.removeAttribute("content");
        }
      };
    };

    document.title =
      "Air Cerdas – Monitoring Air dari HP | Kontrol Pemakaian Air Lebih Mudah";

    const cleanupMeta = [
      upsertMeta(
        'meta[name="description"]',
        "name",
        "description",
        `Pantau pemakaian air lebih mudah dari HP dengan Air Cerdas. Harga promo ${PRICE_NEW} per produk, dapat video panduan instalasi dan pendampingan awal.`,
      ),
      upsertMeta(
        'meta[name="keywords"]',
        "name",
        "keywords",
        "air cerdas, smart water monitor, pantau air dari hp, kontrol tagihan air, monitor pemakaian air",
      ),
      upsertMeta(
        'meta[property="og:title"]',
        "property",
        "og:title",
        "Air Cerdas – Monitoring Air dari HP | Kontrol Pemakaian Air Lebih Mudah",
      ),
      upsertMeta(
        'meta[property="og:description"]',
        "property",
        "og:description",
        `Air Cerdas membantu Anda memantau pemakaian air lebih praktis. Promo ${PRICE_NEW} per produk.`,
      ),
    ];

    const mobileTimer = setInterval(() => {
      setMobileIndex((prev) => (prev + 1) % MOBILE_IMAGES.length);
    }, 3000);

    const webTimer = setInterval(() => {
      setWebIndex((prev) => (prev + 1) % WEB_IMAGES.length);
    }, 4000);

    return () => {
      document.title = originalTitle;
      cleanupMeta.forEach((cleanup) => cleanup());
      clearInterval(mobileTimer);
      clearInterval(webTimer);
    };
  }, []);

  return (
    <>
      <div className="min-h-screen bg-gray-100 py-8 pb-24 text-gray-800 transition-colors duration-300 dark:bg-gray-900 dark:text-gray-200 md:py-16 md:pb-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <section className="mb-16 pt-8 text-center">
            <div className="mb-6 inline-block rounded-full bg-blue-100 px-4 py-1 text-sm font-semibold text-blue-800 dark:bg-blue-900 dark:text-blue-200">
              Air Cerdas — Smart Water Monitor
            </div>

            <h1 className="mb-6 text-4xl font-extrabold leading-tight text-blue-700 dark:text-blue-400 md:text-5xl lg:text-6xl">
              Tagihan Air Tiba-Tiba Naik?
              <br className="hidden md:block" />
              <span className="text-gray-900 dark:text-white">
                {" "}
                Bisa Jadi Ada Aliran yang Tidak Terpantau.
              </span>
            </h1>

            <p className="mx-auto mb-8 max-w-3xl text-lg leading-relaxed text-gray-700 dark:text-gray-300 md:text-xl">
              Air Cerdas membantu Anda memantau pemakaian air dari HP dengan
              cara yang lebih mudah dipahami. Cocok untuk rumah, kos, kontrakan,
              ruko, hingga apartemen kecil yang ingin mulai lebih rapi
              mengontrol penggunaan air.
            </p>

            <div className="mx-auto mb-8 max-w-2xl rounded-2xl border border-blue-100 bg-white p-6 shadow-xl dark:border-gray-700 dark:bg-gray-800 md:p-8">
              <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
                <div className="text-left">
                  <p className="mb-1 text-sm font-bold uppercase tracking-wider text-red-500">
                    Promo Spesial Hari Ini
                  </p>
                  <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-end sm:gap-3">
                    <span className="text-xl text-gray-400 line-through decoration-red-500 sm:text-2xl">
                      {PRICE_OLD}
                    </span>
                    <div className="flex items-end gap-2">
                      <span className="text-3xl font-extrabold leading-none text-gray-900 dark:text-white sm:text-4xl">
                        {PRICE_NEW}
                      </span>
                      <span className="pb-1 text-sm text-gray-500 dark:text-gray-400 sm:text-base">
                        / produk
                      </span>
                    </div>
                  </div>
                </div>

                <div className="space-y-2 text-left">
                  <p className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
                    <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                    Dapat video panduan instalasi
                  </p>
                  <p className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
                    <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                    Dibimbing sampai alat terpasang
                  </p>
                  <p className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
                    <span className="mr-2 font-bold text-blue-600">✓</span> Bisa
                    konsultasi sebelum beli
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-8 flex flex-col justify-center gap-4 sm:flex-row">
              <a
                href={createWaLink(
                  `Halo, saya tertarik dengan Air Cerdas harga promo ${PRICE_NEW}. Boleh tanya-tanya dulu?`,
                )}
                target="_blank"
                rel="noopener noreferrer"
                className={buttonPrimaryClass}
              >
                Chat WhatsApp Sekarang
              </a>
              <a href="#cara-kerja" className={buttonSecondaryClass}>
                Lihat Cara Kerjanya
              </a>
            </div>

            <div className="pt-2">
              <p className="mb-4 text-sm font-medium text-gray-500 dark:text-gray-400">
                Atau beli melalui marketplace resmi kami:
              </p>
              <div className="flex flex-col justify-center gap-4 sm:flex-row">
                <a
                  href={TOKPED_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-xl bg-[#00AA5B] px-6 py-3 font-bold text-white shadow-md transition-colors hover:bg-[#008f4c]"
                >
                  Belanja di Tokopedia
                </a>
                <a
                  href={SHOPEE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-xl bg-[#EE4D2D] px-6 py-3 font-bold text-white shadow-md transition-colors hover:bg-[#d74223]"
                >
                  Belanja di Shopee
                </a>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <div className="mb-8 rounded-3xl bg-white p-8 shadow-md transition-colors duration-300 dark:bg-gray-800 md:p-12">
              <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
                <div>
                  <h2 className="mb-6 text-3xl font-bold leading-tight text-gray-900 dark:text-gray-100">
                    Kadang Masalahnya Bukan Pemakaian Berlebih, tapi Aliran Air
                    yang Tidak Disadari
                  </h2>
                  <div className="space-y-4 text-lg text-gray-700 dark:text-gray-300">
                    <p>
                      Banyak orang baru sadar ada masalah saat tagihan air sudah
                      terlanjur naik. Padahal penyebabnya bisa sangat sederhana:
                      rembesan kecil, aliran yang terus berjalan, atau pemakaian
                      yang tidak terkontrol.
                    </p>
                    <p>
                      Hal seperti ini sering tidak terlihat dari luar. Tidak
                      selalu ada genangan, dan tidak selalu ada pipa yang tampak
                      rusak. Justru yang sering merugikan adalah kebocoran kecil
                      yang dibiarkan berjam-jam atau berhari-hari.
                    </p>
                    <p className="font-semibold text-red-600 dark:text-red-400">
                      Akhirnya, yang datang lebih dulu bukan solusi, tapi
                      tagihan.
                    </p>
                    <p>
                      Air Cerdas membantu Anda melihat pemakaian air dengan data
                      yang lebih mudah dipantau, supaya Anda tidak terus
                      mengandalkan tebakan.
                    </p>
                  </div>
                </div>

                <div className="flex justify-center">
                  <img
                    src="/images/masalah-tagihan-air.webp"
                    alt="Ilustrasi tagihan air membengkak"
                    className="h-auto w-full max-w-md rounded-2xl object-cover shadow-xl"
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
              <div className="rounded-3xl border border-red-100 bg-red-50 p-8 dark:border-red-900/30 dark:bg-red-900/20">
                <h3 className="mb-4 text-2xl font-bold text-gray-900 dark:text-white">
                  Masalah yang Sering Terjadi
                </h3>
                <p className="mb-4 text-gray-700 dark:text-gray-300">
                  Dalam praktik sehari-hari, lonjakan tagihan sering muncul
                  karena hal-hal berikut:
                </p>
                <ul className="space-y-3 text-gray-700 dark:text-gray-300">
                  <li className="flex items-start">
                    <span className="mr-2 font-bold text-red-500">-</span>{" "}
                    Rembesan kecil yang dibiarkan
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2 font-bold text-red-500">-</span>{" "}
                    Pemakaian air yang tidak terkontrol
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2 font-bold text-red-500">-</span>{" "}
                    Lonjakan pemakaian yang tidak cepat terlihat
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2 font-bold text-red-500">-</span> Tidak
                    ada data harian yang mudah dibaca
                  </li>
                </ul>
              </div>

              <div className="rounded-3xl border border-blue-100 bg-blue-50 p-8 dark:border-blue-900/30 dark:bg-blue-900/20">
                <h3 className="mb-4 text-2xl font-bold text-gray-900 dark:text-white">
                  Kenapa Cek Manual Sering Terlambat?
                </h3>
                <p className="mb-4 text-gray-700 dark:text-gray-300">
                  Melihat meter air sesekali memang membantu, tetapi sering kali
                  itu belum cukup. Kebocoran atau aliran yang tidak normal bisa
                  terjadi saat malam hari, saat rumah kosong, atau saat Anda
                  sedang sibuk.
                </p>
                <p className="mb-2 font-semibold text-gray-700 dark:text-gray-300">
                  Kalau hanya mengandalkan perkiraan, biasanya Anda baru tahu
                  saat tagihan sudah naik.
                </p>
                <p className="italic text-gray-700 dark:text-gray-300">
                  “Yang sering bikin rugi bukan cuma air yang keluar, tetapi
                  keterlambatan menyadari masalahnya.”
                </p>
              </div>
            </div>
          </section>

          <section className="mb-16 rounded-3xl border border-gray-100 bg-white p-8 shadow-lg transition-colors duration-300 dark:border-gray-700 dark:bg-gray-800 md:p-12">
            <div className="mb-12 text-center">
              <h2 className="mb-4 text-3xl font-bold text-gray-900 dark:text-white md:text-4xl">
                Solusinya: Air Cerdas
              </h2>
              <p className="text-xl font-medium text-blue-600 dark:text-blue-400">
                Monitoring air yang praktis, rapi, dan lebih mudah dipahami.
              </p>
            </div>

            <p className="mx-auto mb-12 max-w-4xl text-center text-lg text-gray-700 dark:text-gray-300">
              Air Cerdas membantu Anda melihat pemakaian air secara lebih jelas.
              Bukan untuk menakut-nakuti, tetapi untuk memberi Anda kontrol yang
              lebih baik sebelum masalah membesar.
            </p>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
              {benefits.map((item) => (
                <div
                  key={item.title}
                  className="rounded-xl p-4 transition-colors hover:bg-gray-50 dark:hover:bg-gray-700/50"
                >
                  <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section
            id="cara-kerja"
            className="mb-16 rounded-3xl bg-gray-50 p-8 transition-colors duration-300 dark:bg-gray-900/50 md:p-12"
          >
            <h2 className="mb-12 text-center text-3xl font-bold text-gray-900 dark:text-white md:text-4xl">
              Cara Kerjanya Sederhana
            </h2>

            <div className="relative flex flex-col items-start justify-center gap-8 md:flex-row md:gap-4">
              <div className="absolute left-[15%] right-[15%] top-8 z-0 hidden h-1 bg-blue-200 dark:bg-blue-800/50 md:block"></div>

              {[
                {
                  number: "1",
                  title: "Pasang di Jalur Air",
                  description:
                    "Sensor dipasang pada jalur air yang ingin Anda pantau.",
                },
                {
                  number: "2",
                  title: "Hubungkan Sistem",
                  description:
                    "Setelah aktif dan terhubung Wi-Fi, data bisa mulai dipantau dari handphone.",
                },
                {
                  number: "3",
                  title: "Pantau dengan Lebih Tenang",
                  description:
                    "Saat ada lonjakan pemakaian yang terasa tidak wajar, Anda bisa lebih cepat mengeceknya.",
                },
              ].map((step) => (
                <div
                  key={step.number}
                  className="relative z-10 flex flex-1 flex-col items-center text-center"
                >
                  <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full border-4 border-white bg-blue-600 text-2xl font-bold text-white dark:border-gray-900">
                    {step.number}
                  </div>
                  <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>

            <p className="mt-10 text-center font-medium text-gray-700 dark:text-gray-300">
              Tujuan Air Cerdas bukan membuat semuanya terasa teknis, tetapi
              justru membantu kontrol air jadi lebih sederhana.
            </p>
          </section>

          <section className="mb-16">
            <div className="mb-10 text-center">
              <h2 className="mb-4 text-3xl font-bold text-gray-900 dark:text-white md:text-4xl">
                Pasang di Mana? Sesuaikan dengan Tujuan Monitoring Anda
              </h2>
              <p className="mx-auto max-w-3xl text-lg text-gray-600 dark:text-gray-400">
                Tidak semua orang punya tujuan yang sama. Ada yang ingin tahu
                total pemakaian air bangunan, ada yang ingin melacak titik yang
                paling boros, dan ada juga yang hanya ingin mencoba dulu. Karena
                itu, titik pemasangannya bisa disesuaikan.
              </p>
            </div>

            <div className="mb-10 grid grid-cols-1 gap-8 md:grid-cols-3">
              <div className="flex h-full flex-col overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
                <img
                  src={imgMonitoringTotal}
                  alt="Monitoring total pemakaian air"
                  className="h-48 w-full border-b border-gray-100 object-cover dark:border-gray-700"
                />
                <div className="flex flex-grow flex-col p-8">
                  <div className="mb-4 inline-block self-start rounded-full bg-blue-100 px-3 py-1 text-sm font-bold text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                    Opsi 1
                  </div>
                  <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
                    Pantau Total Pemakaian Air
                  </h3>
                  <p className="mb-4 text-sm font-semibold text-blue-600 dark:text-blue-400">
                    Pasang sensor di jalur utama, dekat tandon, atau dekat
                    sumber distribusi utama.
                  </p>
                  <p className="mb-4 text-sm text-gray-700 dark:text-gray-300">
                    Ini cocok untuk Anda yang ingin melihat gambaran umum
                    pemakaian air seluruh bangunan secara lebih rapi.
                  </p>
                  <div className="mb-4">
                    <p className="mb-2 text-sm font-semibold text-gray-900 dark:text-gray-200">
                      Dengan pemasangan ini, Anda bisa:
                    </p>
                    <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                      <li>
                        <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                        melihat total pemakaian air
                      </li>
                      <li>
                        <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                        memahami pola pemakaian harian
                      </li>
                      <li>
                        <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                        punya titik kontrol utama
                      </li>
                    </ul>
                  </div>
                  <div className="mt-auto border-t border-gray-100 pt-4 dark:border-gray-700">
                    <p className="text-xs italic text-gray-500 dark:text-gray-400">
                      Ini biasanya pilihan paling pas untuk tahap awal.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex h-full flex-col overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
                <img
                  src={imgTitikKebocoran}
                  alt="Mengetahui titik kebocoran air"
                  className="h-48 w-full border-b border-gray-100 object-cover dark:border-gray-700"
                />
                <div className="flex flex-grow flex-col p-8">
                  <div className="mb-4 inline-block self-start rounded-full bg-green-100 px-3 py-1 text-sm font-bold text-green-800 dark:bg-green-900 dark:text-green-200">
                    Opsi 2
                  </div>
                  <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
                    Pantau Jalur yang Lebih Spesifik
                  </h3>
                  <p className="mb-4 text-sm font-semibold text-green-600 dark:text-green-400">
                    Pasang sensor pada tiap jalur menuju keran atau titik
                    pemakaian tertentu.
                  </p>
                  <p className="mb-4 text-sm text-gray-700 dark:text-gray-300">
                    Ini cocok bila Anda ingin tahu area mana yang paling sering
                    memakai air atau jalur mana yang terasa tidak normal.
                  </p>
                  <div className="mb-4">
                    <p className="mb-2 text-sm font-semibold text-gray-900 dark:text-gray-200">
                      Dengan cara ini, Anda bisa lebih mudah melihat:
                    </p>
                    <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                      <li>
                        <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                        jalur yang terus mengalir
                      </li>
                      <li>
                        <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                        area dengan pemakaian tidak wajar
                      </li>
                      <li>
                        <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                        titik yang perlu dicek lebih lanjut
                      </li>
                    </ul>
                  </div>
                  <div className="mt-auto border-t border-gray-100 pt-4 dark:border-gray-700">
                    <p className="text-xs italic text-gray-500 dark:text-gray-400">
                      Semakin detail titik pemasangan, semakin detail juga
                      informasi yang Anda dapatkan.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex h-full flex-col rounded-3xl border border-gray-100 bg-white p-8 shadow-sm dark:border-gray-700 dark:bg-gray-800">
                <div className="mb-4 inline-block self-start rounded-full bg-yellow-100 px-3 py-1 text-sm font-bold text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">
                  Opsi 3
                </div>
                <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
                  Mulai dari 1 Sensor Dulu
                </h3>
                <p className="mb-4 text-sm font-semibold text-yellow-600 dark:text-yellow-400">
                  Cocok untuk yang ingin coba dulu tanpa langsung pasang di
                  banyak titik.
                </p>
                <p className="mb-4 text-sm text-gray-700 dark:text-gray-300">
                  Anda bisa memulai dari dekat tandon atau jalur utama untuk
                  memahami dulu cara kerja sistem dan cara membaca datanya.
                </p>
                <div className="mb-4">
                  <p className="mb-2 text-sm font-semibold text-gray-900 dark:text-gray-200">
                    Pilihan ini membantu Anda untuk:
                  </p>
                  <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                    <li>
                      <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                      mengenal cara kerja Air Cerdas
                    </li>
                    <li>
                      <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                      melihat bentuk data monitoring
                    </li>
                    <li>
                      <span className="mr-2 font-bold text-blue-600">✓</span>{" "}
                      memulai dengan biaya yang lebih ringan
                    </li>
                  </ul>
                </div>
                <div className="mt-auto border-t border-gray-100 pt-4 dark:border-gray-700">
                  <p className="text-xs italic text-gray-500 dark:text-gray-400">
                    Setelah terasa cocok, sistem bisa diperluas ke titik-titik
                    lain.
                  </p>
                </div>
              </div>
            </div>

            <div className="mx-auto max-w-4xl rounded-2xl border border-blue-100 bg-blue-50 p-6 dark:border-blue-900/30 dark:bg-blue-900/20">
              <h4 className="mb-4 text-center text-lg font-bold text-gray-900 dark:text-white">
                Ringkasnya, pilih titik pemasangan sesuai tujuan Anda
              </h4>
              <ul className="space-y-3 text-sm text-gray-700 dark:text-gray-300 md:text-base">
                <li className="flex items-start gap-3">
                  <span className="mt-1 font-bold text-blue-600">•</span>
                  <p>
                    Ingin tahu <strong>total pemakaian air</strong>? Pasang di
                    dekat tandon atau jalur utama.
                  </p>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 font-bold text-blue-600">•</span>
                  <p>
                    Ingin tahu{" "}
                    <strong>jalur yang perlu dicek lebih lanjut</strong>? Pasang
                    di titik-titik yang lebih spesifik.
                  </p>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 font-bold text-blue-600">•</span>
                  <p>
                    Masih ingin <strong>coba dulu</strong>? Mulai dari 1 sensor
                    sudah cukup masuk akal.
                  </p>
                </li>
              </ul>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="mb-4 text-center text-3xl font-bold text-gray-900 dark:text-white md:text-4xl">
              Air Cerdas Cocok untuk Siapa?
            </h2>
            <p className="mb-10 text-center text-lg text-gray-600 dark:text-gray-400">
              Kalau Anda termasuk salah satu di bawah ini, kemungkinan besar Air
              Cerdas relevan untuk kebutuhan Anda.
            </p>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {targetUsers.map((item) => (
                <div
                  key={item.title}
                  className={`rounded-2xl border border-gray-100 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800 ${
                    item.wide ? "lg:col-span-2" : ""
                  }`}
                >
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="mb-4 h-16 w-16 object-contain"
                  />
                  <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-xl bg-blue-50 p-4 text-center dark:bg-blue-900/20">
              <p className="font-semibold text-blue-800 dark:text-blue-300">
                Intinya sederhana: kalau Anda tidak suka tagihan air naik tanpa
                alasan yang mudah dipahami, Air Cerdas layak dipertimbangkan.
              </p>
            </div>
          </section>

          <section className="mb-16">
            <div className="rounded-3xl bg-gradient-to-br from-blue-600 to-blue-800 p-8 text-white shadow-xl md:p-12">
              <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2">
                <div>
                  <h2 className="mb-4 text-3xl font-bold md:text-4xl">
                    Mulai dari Versi yang Lebih Ringan
                  </h2>
                  <p className="mb-6 text-lg text-blue-100">
                    Kalau selama ini Anda menunda karena merasa alat monitoring
                    air itu mahal atau terlalu teknis, sekarang Anda bisa mulai
                    dari langkah yang lebih sederhana.
                  </p>

                  <div className="mb-6 w-full overflow-hidden rounded-2xl border border-white/20 bg-white/10 p-6 backdrop-blur-sm">
                    <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-end sm:gap-4">
                      <span className="text-xl text-blue-300 line-through decoration-red-400 sm:text-2xl">
                        {PRICE_OLD}
                      </span>
                      <div className="flex items-end gap-2">
                        <span className="text-4xl font-extrabold leading-none text-white sm:text-5xl">
                          {PRICE_NEW}
                        </span>
                        <span className="pb-1 text-sm text-blue-200 sm:text-base">
                          / produk
                        </span>
                      </div>
                    </div>
                  </div>

                  <p className="mb-6 text-sm italic text-blue-100">
                    Cocok untuk yang ingin mulai dari satu titik dulu, memahami
                    sistemnya, lalu memutuskan pengembangan berikutnya dengan
                    lebih yakin.
                  </p>

                  <div className="flex flex-col gap-5">
                    <div className="flex flex-col gap-3 sm:flex-row">
                      <a
                        href={createWaLink(
                          `Halo, saya mau order Air Cerdas harga promo ${PRICE_NEW}.`,
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 rounded-full bg-green-500 px-6 py-3 text-center font-bold text-white shadow transition-colors hover:bg-green-600"
                      >
                        Saya Mau Order via WA
                      </a>
                      <a
                        href={createWaLink(
                          "Halo, saya tertarik dengan Air Cerdas tapi masih ingin tanya dulu.",
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 rounded-full bg-white px-6 py-3 text-center font-bold text-blue-700 shadow transition-colors hover:bg-gray-100"
                      >
                        Saya Mau Tanya Dulu
                      </a>
                    </div>

                    <div className="mt-2 border-t border-blue-500/30 pt-4">
                      <p className="mb-3 text-sm text-blue-100">
                        Tersedia juga di marketplace resmi kami:
                      </p>
                      <div className="flex flex-col gap-3 sm:flex-row">
                        <a
                          href={TOKPED_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 rounded-xl bg-[#00AA5B] px-4 py-2 text-center font-bold text-white shadow transition-colors hover:bg-[#008f4c]"
                        >
                          Beli di Tokopedia
                        </a>
                        <a
                          href={SHOPEE_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 rounded-xl bg-[#EE4D2D] px-4 py-2 text-center font-bold text-white shadow transition-colors hover:bg-[#d74223]"
                        >
                          Beli di Shopee
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="rounded-2xl bg-white p-8 text-gray-900 shadow-lg dark:bg-gray-900 dark:text-white">
                  <h3 className="mb-4 text-2xl font-bold">
                    Tenang, Anda Tidak Dibiarkan Pasang Sendiri
                  </h3>
                  <p className="mb-6 text-sm text-gray-600 dark:text-gray-400">
                    Banyak orang tertarik, tetapi masih takut instalasi terasa
                    membingungkan. Karena itu, kami bantu di tahap awal supaya
                    alatnya benar-benar bisa dipakai.
                  </p>

                  <ul className="mb-6 space-y-4">
                    {[
                      {
                        title: "Video Panduan Instalasi",
                        subtitle: "Langkah awal jadi lebih mudah diikuti.",
                      },
                      {
                        title: "Pendampingan Sampai Terpasang",
                        subtitle: "Kalau bingung, Anda tetap bisa bertanya.",
                      },
                      {
                        title: "Konsultasi Kendala Dasar",
                        subtitle:
                          "Tujuannya agar alat tidak hanya dibeli, tetapi juga benar-benar terpakai.",
                      },
                    ].map((item) => (
                      <li key={item.title} className="flex items-start">
                        <span className="mr-3 text-xl font-bold text-blue-600">
                          ✓
                        </span>
                        <div>
                          <strong className="block">{item.title}</strong>
                          <span className="text-sm text-gray-500 dark:text-gray-400">
                            {item.subtitle}
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <p className="text-center text-sm font-semibold text-blue-600 dark:text-blue-400">
                    Jadi Anda tidak perlu merasa harus jago teknis dulu untuk
                    mulai mencoba.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="mx-auto mb-16 max-w-4xl text-center">
            <h2 className="mb-6 text-3xl font-bold text-gray-900 dark:text-white">
              Yang Anda Beli Bukan Sekadar Alat, tapi Rasa Lebih Tenang saat
              Mengontrol Pemakaian Air
            </h2>
            <div className="rounded-3xl border border-gray-100 bg-white p-8 shadow-sm dark:border-gray-700 dark:bg-gray-800">
              <p className="mb-4 text-lg text-gray-700 dark:text-gray-300">
                Banyak kerugian kecil terjadi bukan karena orang sengaja boros,
                tetapi karena tidak ada data yang mudah dilihat. Saat pemakaian
                air mulai terasa tidak wajar, Anda jadi punya dasar yang lebih
                jelas untuk mengecek.
              </p>

              <div className="mx-auto my-6 max-w-md rounded-xl bg-gray-50 p-6 text-left dark:bg-gray-900">
                <p className="mb-3 font-semibold text-gray-900 dark:text-white">
                  Air Cerdas membantu Anda beralih dari:
                </p>
                <ul className="list-inside list-disc space-y-2 text-gray-700 dark:text-gray-300">
                  <li>
                    tidak tahu{" "}
                    <span className="font-bold text-blue-600 dark:text-blue-400">
                      menjadi lebih paham
                    </span>
                  </li>
                  <li>
                    hanya curiga{" "}
                    <span className="font-bold text-blue-600 dark:text-blue-400">
                      menjadi bisa memantau
                    </span>
                  </li>
                  <li>
                    telat sadar{" "}
                    <span className="font-bold text-blue-600 dark:text-blue-400">
                      menjadi lebih cepat cek
                    </span>
                  </li>
                </ul>
              </div>

              <p className="italic text-gray-700 dark:text-gray-300">
                Dalam banyak kasus, harga promo {PRICE_NEW} jauh lebih ringan
                dibanding kebocoran atau pemborosan yang berulang tanpa
                disadari.
              </p>
            </div>
          </section>

          <section className="mb-16 rounded-3xl border border-gray-100 bg-white p-8 shadow-md transition-colors duration-300 dark:border-gray-700 dark:bg-gray-800 md:p-12">
            <div className="mb-12 text-center">
              <h2 className="mb-4 text-3xl font-bold text-gray-900 dark:text-white md:text-4xl">
                Lihat Langsung Produk dan Tampilannya
              </h2>
              <p className="mx-auto max-w-2xl text-lg text-gray-600 dark:text-gray-400">
                Banyak orang lebih yakin setelah melihat bentuk alatnya dan
                bagaimana tampilannya saat dipantau. Karena itu, kami tampilkan
                video dan screenshot aplikasinya secara langsung.
              </p>
            </div>

            <div className="mb-16 grid grid-cols-1 items-start gap-12 lg:grid-cols-2">
              <div>
                <h3 className="mb-6 text-center text-xl font-bold text-gray-900 dark:text-white">
                  Video Cara Kerja Lengkap
                </h3>
                <div className="aspect-w-16 aspect-h-9 w-full overflow-hidden rounded-2xl bg-gray-200 shadow-lg dark:bg-gray-700">
                  <iframe
                    src="https://www.youtube.com/embed/1L5tFK0DLF8"
                    title="Video cara kerja Air Cerdas"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="h-full w-full"
                  ></iframe>
                </div>
              </div>

              <div>
                <h3 className="mb-6 text-center text-xl font-bold text-gray-900 dark:text-white">
                  Cuplikan Singkat
                </h3>
                <div className="aspect-w-9 aspect-h-10 mx-auto w-full max-w-xs overflow-hidden rounded-2xl bg-gray-200 shadow-lg dark:bg-gray-700">
                  <iframe
                    src="https://www.youtube.com/embed/JTTAFbhrY9w"
                    title="Short video Air Cerdas"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="h-full w-full"
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-12 dark:border-gray-700">
              <h3 className="mb-10 text-center text-2xl font-bold text-gray-900 dark:text-white">
                Tampilan Monitoring di Berbagai Perangkat
              </h3>

              <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
                <div>
                  <h4 className="mb-6 text-center text-lg font-bold text-gray-900 dark:text-white">
                    Web Dashboard (Laptop/PC)
                  </h4>
                  <div className="mx-auto w-full max-w-lg">
                    <div className="relative aspect-video rounded-t-xl border-[8px] border-gray-800 bg-gray-800 shadow-xl">
                      <div className="group relative h-full w-full overflow-hidden bg-white">
                        <img
                          src={WEB_IMAGES[webIndex]}
                          className="h-full w-full object-cover transition-opacity duration-500"
                          alt={`Tampilan web ${webIndex + 1}`}
                        />
                        <button
                          onClick={() =>
                            setWebIndex((prev) =>
                              prev === 0 ? WEB_IMAGES.length - 1 : prev - 1,
                            )
                          }
                          className="absolute left-2 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-black/60 font-bold text-white opacity-0 transition-opacity hover:bg-black/80 group-hover:opacity-100"
                          aria-label="Slide web sebelumnya"
                        >
                          ‹
                        </button>
                        <button
                          onClick={() =>
                            setWebIndex(
                              (prev) => (prev + 1) % WEB_IMAGES.length,
                            )
                          }
                          className="absolute right-2 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-black/60 font-bold text-white opacity-0 transition-opacity hover:bg-black/80 group-hover:opacity-100"
                          aria-label="Slide web berikutnya"
                        >
                          ›
                        </button>
                      </div>
                    </div>

                    <div className="relative h-4 rounded-b-2xl bg-gray-400 shadow-2xl dark:bg-gray-600">
                      <div className="absolute left-1/2 top-0 h-1 w-16 -translate-x-1/2 rounded-b-md bg-gray-300 dark:bg-gray-500"></div>
                    </div>

                    <div className="mt-6 flex justify-center space-x-2">
                      {WEB_IMAGES.map((_, idx) => (
                        <button
                          key={`web-dot-${idx}`}
                          onClick={() => setWebIndex(idx)}
                          aria-label={`Slide web ${idx + 1}`}
                          className={`h-2.5 w-2.5 rounded-full transition-colors ${
                            idx === webIndex
                              ? "bg-blue-600"
                              : "bg-gray-300 hover:bg-gray-400 dark:bg-gray-600"
                          }`}
                        ></button>
                      ))}
                    </div>
                  </div>
                </div>

                <div>
                  <h4 className="mb-6 text-center text-lg font-bold text-gray-900 dark:text-white">
                    Mobile App (Smartphone)
                  </h4>
                  <div className="mx-auto w-[250px] sm:w-[280px]">
                    <div className="relative aspect-[9/19] rounded-[2.5rem] border-[10px] border-gray-800 bg-gray-800 shadow-xl">
                      <div className="absolute left-1/2 top-0 z-20 h-5 w-24 -translate-x-1/2 rounded-b-xl bg-gray-800"></div>

                      <div className="group relative h-full w-full overflow-hidden rounded-[1.8rem] bg-white">
                        <img
                          src={MOBILE_IMAGES[mobileIndex]}
                          className="h-full w-full object-cover transition-opacity duration-500"
                          alt={`Tampilan mobile ${mobileIndex + 1}`}
                        />
                        <button
                          onClick={() =>
                            setMobileIndex((prev) =>
                              prev === 0 ? MOBILE_IMAGES.length - 1 : prev - 1,
                            )
                          }
                          className="absolute left-2 top-1/2 z-30 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-black/60 font-bold text-white opacity-0 transition-opacity hover:bg-black/80 group-hover:opacity-100"
                          aria-label="Slide mobile sebelumnya"
                        >
                          ‹
                        </button>
                        <button
                          onClick={() =>
                            setMobileIndex(
                              (prev) => (prev + 1) % MOBILE_IMAGES.length,
                            )
                          }
                          className="absolute right-2 top-1/2 z-30 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-black/60 font-bold text-white opacity-0 transition-opacity hover:bg-black/80 group-hover:opacity-100"
                          aria-label="Slide mobile berikutnya"
                        >
                          ›
                        </button>
                      </div>
                    </div>

                    <div className="mt-6 flex justify-center space-x-2">
                      {MOBILE_IMAGES.map((_, idx) => (
                        <button
                          key={`mobile-dot-${idx}`}
                          onClick={() => setMobileIndex(idx)}
                          aria-label={`Slide mobile ${idx + 1}`}
                          className={`h-2.5 w-2.5 rounded-full transition-colors ${
                            idx === mobileIndex
                              ? "bg-blue-600"
                              : "bg-gray-300 hover:bg-gray-400 dark:bg-gray-600"
                          }`}
                        ></button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 flex justify-center">
              <a
                href={createWaLink(
                  "Halo, saya mau tanya lebih detail soal tampilan aplikasi dan alat Air Cerdas.",
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block rounded-full bg-blue-600 px-8 py-4 font-semibold text-white shadow-lg transition-colors hover:bg-blue-700"
              >
                Chat Jika Mau Ditanya Lebih Dulu
              </a>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="mb-4 text-center text-3xl font-bold text-gray-900 dark:text-white">
              Kenapa Banyak Orang Merasa Cocok dengan Air Cerdas?
            </h2>
            <p className="mx-auto mb-10 max-w-2xl text-center text-gray-600 dark:text-gray-400">
              Bukan karena tampilannya rumit atau terlalu canggih, tetapi karena
              sistem ini membantu orang lebih cepat sadar saat pemakaian air
              mulai terasa tidak normal.
            </p>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {reasonsToChoose.map((item) => (
                <div
                  key={item.title}
                  className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800"
                >
                  <div className="mb-4 text-lg font-bold text-yellow-500">
                    Poin Utama
                  </div>
                  <h3 className="mb-3 text-lg font-bold text-gray-900 dark:text-white">
                    {item.title}
                  </h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section className="mx-auto mb-16 max-w-4xl rounded-3xl border border-gray-100 bg-white p-8 shadow-md transition-colors duration-300 dark:border-gray-700 dark:bg-gray-800 md:p-12">
            <h2 className="mb-10 text-center text-3xl font-bold text-gray-900 dark:text-white">
              Pertanyaan yang Paling Sering Ditanyakan
            </h2>
            <div className="space-y-4">
              {faqs.map((faq) => (
                <details
                  key={faq.question}
                  className="group border-b border-gray-200 pb-4 dark:border-gray-700"
                >
                  <summary className="flex cursor-pointer list-none items-center justify-between text-lg font-bold text-gray-900 dark:text-white">
                    <span>{faq.question}</span>
                    <span className="transition group-open:rotate-180">
                      <ChevronIcon />
                    </span>
                  </summary>
                  <p className="mt-3 text-gray-600 dark:text-gray-400">
                    {faq.answer}
                  </p>
                </details>
              ))}
            </div>
          </section>

          <section className="mb-16 rounded-3xl bg-white p-8 shadow-md transition-colors duration-300 dark:bg-gray-800">
            <h2 className="mb-8 text-center text-3xl font-bold text-gray-900 dark:text-white">
              Lokasi Kami di Depok, Jawa Barat
            </h2>
            <div className="aspect-w-16 aspect-h-9 mx-auto w-full max-w-3xl overflow-hidden rounded-2xl border border-gray-200 shadow-sm dark:border-gray-700">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.2106119069576!2d106.8765365793457!3d-6.366784099999989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69ed48502a0b5f%3A0x8b3071078865910d!2sAir%20Cerdas!5e0!3m2!1sid!2sid!4v1775400138972!5m2!1sid!2sid"
                title="Lokasi Air Cerdas di Depok"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: "400px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="h-full w-full"
              ></iframe>
            </div>
          </section>

          <section className="relative mt-16 overflow-hidden rounded-3xl bg-gray-900 p-8 text-center text-white shadow-2xl dark:bg-black md:p-12">
            <div className="absolute left-0 top-0 h-2 w-full bg-gradient-to-r from-blue-500 via-green-500 to-yellow-500"></div>

            <h2 className="mb-6 text-3xl font-extrabold leading-tight md:text-5xl">
              Tidak Harus Menunggu Tagihan Membengkak untuk Mulai Lebih Tertib
            </h2>
            <p className="mx-auto mb-8 max-w-3xl text-xl text-gray-300">
              Kalau Anda sudah beberapa kali merasa tagihan air naik tanpa
              alasan yang mudah dipahami, Air Cerdas bisa menjadi langkah awal
              yang masuk akal untuk mulai memantau dengan lebih tenang.
            </p>

            <div className="mx-auto mb-8 w-full max-w-xl overflow-hidden rounded-2xl border border-white/20 bg-white/10 p-6 backdrop-blur-md">
              <p className="mb-2 text-sm font-bold uppercase tracking-widest text-blue-300">
                Promo Mulai Hari Ini
              </p>
              <div className="mb-4 flex flex-col items-center gap-2 sm:flex-row sm:items-end sm:justify-center sm:gap-4">
                <span className="text-2xl text-gray-400 line-through sm:text-3xl">
                  {PRICE_OLD}
                </span>
                <div className="flex items-end gap-2">
                  <span className="text-4xl font-extrabold leading-none text-green-400 sm:text-5xl">
                    {PRICE_NEW}
                  </span>
                  <span className="pb-1 text-sm text-gray-300 sm:text-lg">/ produk</span>
                </div>
              </div>
              <ul className="mx-auto mt-4 max-w-xs space-y-2 text-left text-sm text-gray-200">
                <li>
                  <span className="mr-2 font-bold text-green-400">✓</span> Dapat
                  video panduan instalasi
                </li>
                <li>
                  <span className="mr-2 font-bold text-green-400">✓</span>{" "}
                  Dibimbing sampai alat terpasang
                </li>
                <li>
                  <span className="mr-2 font-bold text-green-400">✓</span> Bisa
                  konsultasi awal
                </li>
              </ul>
            </div>

            <div className="mb-8 flex flex-col justify-center gap-4 sm:flex-row">
              <a
                href={createWaLink(
                  `Halo, saya mau mulai pakai Air Cerdas dengan promo ${PRICE_NEW}.`,
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block rounded-full bg-green-600 px-8 py-4 text-lg font-bold text-white shadow-lg transition-all duration-300 hover:scale-[1.02] hover:bg-green-700"
              >
                Chat WhatsApp Sekarang
              </a>
              <a
                href={createWaLink(
                  "Halo, saya mau konsultasi dulu sebelum beli Air Cerdas.",
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block rounded-full border-2 border-gray-500 bg-transparent px-8 py-4 text-lg font-bold text-white transition-all duration-300 hover:border-white hover:bg-white/10"
              >
                Saya Mau Konsultasi Dulu
              </a>
            </div>

            <div className="mx-auto w-full max-w-xl border-t border-gray-800 pt-8">
              <p className="mb-4 text-sm font-medium text-gray-400">
                Beli sekarang melalui marketplace:
              </p>
              <div className="flex flex-col justify-center gap-4 sm:flex-row">
                <a
                  href={TOKPED_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 rounded-xl bg-[#00AA5B] px-6 py-3 font-bold text-white shadow transition-colors hover:bg-[#008f4c]"
                >
                  Tokopedia
                </a>
                <a
                  href={SHOPEE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 rounded-xl bg-[#EE4D2D] px-6 py-3 font-bold text-white shadow transition-colors hover:bg-[#d74223]"
                >
                  Shopee
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div className="fixed bottom-0 left-0 z-50 flex w-full items-center justify-between border-t border-gray-200 bg-white p-3 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] dark:border-gray-800 dark:bg-gray-900 md:hidden">
        <div className="flex flex-col">
          <span className="text-xs font-bold text-red-500">
            Air Cerdas Promo
          </span>
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 line-through">{PRICE_OLD}</span>
            <span className="text-lg font-extrabold text-gray-900 dark:text-white">
              {PRICE_NEW}
            </span>
          </div>
        </div>

        <a
          href={createWaLink(
            `Halo, saya mau order Air Cerdas promo ${PRICE_NEW}.`,
          )}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 rounded-full bg-green-600 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-green-700"
        >
          Chat WA
        </a>
      </div>
    </>
  );
};

export default SmartWaterMonitor;
